var NeoStrings = {
    errors: {
        concurrencyTitle: "Concurrency error",
        concurrencyBody: "Someone else modified the record before you saved it. Please reload it and try again.",
        generalTitle: "Error",
        invalidDataTitle: "Invalid data",
        /** 400 error for non get requests */
        invalidDataBody: "Cannot continue due to the following validation errors:",
        /** 400 error for get requests */
        invalidDataBodyGet: "Incorrect data was provided.",
        notAuthenticatedTitle: "Not authenticated",
        notAuthenticatedBody: "You are not logged in. Please reload the page to login again.",
        unAuthorisedTitle: "Unauthorised",
        unAuthorisedBody: "You do not have access to perform this operation."
    },
    fileManager: {
        uploadErrorTitle: "File upload error",
        /** {0} is the extension of the file */
        uploadErrorBody: "File extension: {0} is not allowed."
    },
    modals: {
        cancel: "Cancel",
        no: "No",
        ok: "Ok",
        yes: "Yes",
    },
    validation: {
        /** Default text to display for built in rules. */
        rules: {
            /** {0} is the field name */
            required: "{0} is required",
            /** {0} is the current value */
            emailAddress: "{0} is not a valid email address",
            /** {0} is the field name */
            regExp: "{0} is in an invalid format",
            /** Displayed when the string is too short */
            stringLengthLessThan: "{0} cannot be less than {1} characters in length",
            /** Displayed when the string is too long */
            stringLengthMoreThan: "{0} cannot be more than {1} characters in length"
        }
    }
};
export default NeoStrings;
